import React, {useEffect} from 'react';
import './App.css';
import {AuthorizationService} from "./services/AuthorizationService";

function App() {

    const authorizationServer = new AuthorizationService()

    function handleLoginClick() {
        authorizationServer.requestAuthorizationCode()
    }

    useEffect(() => {
        handleLoginClick()
    }, [])

    return (
        <div></div>
    )
}

export default App;